import CommonTimeSheetTable from "../../common/Timesheet/TimesheetTable";
const TimeSheetTab = () => {
  return (
    <CommonTimeSheetTable
      updatePath="task/timelog"
      isProject={true}
      isModule={false}
    />
  );
};
export default TimeSheetTab;
